import {motion, useReducedMotion} from 'motion/react';

/** Estrella de 4 puntas del toolkit (como las del lockup), con twinkle sutil. */
export function Sparkle({className, size = 18, delay = 0}: {className?: string; size?: number; delay?: number}) {
  const reduced = useReducedMotion();
  return (
    <motion.svg
      viewBox="0 0 24 24"
      width={size}
      height={size}
      aria-hidden
      className={className}
      animate={reduced ? undefined : {opacity: [0.35, 0.9, 0.35], scale: [0.9, 1.08, 0.9]}}
      transition={{duration: 3.2, delay, repeat: Infinity, ease: 'easeInOut'}}
    >
      <path
        d="M12 0 C13.2 7.2 16.8 10.8 24 12 C16.8 13.2 13.2 16.8 12 24 C10.8 16.8 7.2 13.2 0 12 C7.2 10.8 10.8 7.2 12 0 Z"
        fill="var(--cream)"
      />
    </motion.svg>
  );
}
